import axios, { AxiosError } from 'axios';
import { IRanking } from '@pec/aion-ui-core/interfaces/ranking';
import { RootState } from 'combineReducers';
import { sendError } from '@pec/aion-ui-core/sendError';
import { ThunkAction } from 'redux-thunk';

const fetchClientRankingsRequest = (organizationId: string) =>
  ({
    type: 'FETCH_CLIENT_RANKINGS_REQUEST',
    organizationId
  } as const);

const fetchClientRankingsSuccess = (organizationId: string, payload: IRanking) =>
  ({
    type: 'FETCH_CLIENT_RANKINGS_SUCCESS',
    organizationId,
    payload
  } as const);

const fetchClientRankingsFailure = (organizationId: string, error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_CLIENT_RANKINGS_FAILURE',
    organizationId,
    error
  } as const;
};

const shouldFetchClientRankings = (state: RootState, organizationId: string) => {
  const clientRankingsValues = state.clientRankings[organizationId];
  return !clientRankingsValues;
};

export const fetchClientRankings = (
  organizationId: string,
  contractorId: string
): ThunkAction<void, RootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchClientRankingsRequest(organizationId));

    const response = await axios.get<IRanking>(
      `/api/v3/rankings?clientId=${organizationId}&contractorId=${contractorId}`
    );

    dispatch(fetchClientRankingsSuccess(organizationId, response.data));
  } catch (error) {
    dispatch(fetchClientRankingsFailure(organizationId, error));
  }
};

export const fetchClientRankingsIfNeeded = (
  organizationId: string,
  contractorId: string
): ThunkAction<void, RootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchClientRankings(getState(), organizationId)) {
    dispatch(fetchClientRankings(organizationId, contractorId));
  }
};

export type Actions =
  | ReturnType<typeof fetchClientRankingsRequest>
  | ReturnType<typeof fetchClientRankingsSuccess>
  | ReturnType<typeof fetchClientRankingsFailure>;
